export default {
  introduce: {
    title: 'New Pricing Model',
    cost: 'Billing Based on Ad Impressions',
    limit: 'Top 50',
    gift: 'Apply for the New User Bundle now.',
    describe:
      'First 50 customers activating and completing initial deposit will get the New User Bundle, including 2 showcases from the Mindworks team.',
  },
  form: {
    name: 'Please enter your name',
    email: 'Please enter your email',
    validate: 'Email format is incorrect',
    remark: 'Please leave a message',
    send: 'Apply Now',
    success: 'Thank you for contacting us. We will get back to you soon!',
  },
  suggest: {
    chargMode: {
      title: 'Pricing Model',
      describe: 'Billed based on material impressions on Mintegral.',
    },
    cpmPrice: {
      title: 'CPM Price',
      describe: '$0.5 per thousand impressions for a single material',
    },
    cappMechanism: {
      title: 'Ceiling Mechanism',
      describe: 'Each material cost capped at $800 and no further accumulation',
    },
    minRecharge: {
      title: 'Minimum Recharge',
      describe:
        'Minimum amount is $800, which is a prepayment to ensure the continuity and stability of ad delivery.',
    },
  },
  problem: {
    title: 'FAQ',
    question1:
      'Is the advertising cost billing model suitable for all channels?',
    question2: 'How is CPM cost calculated?',
    question3: 'What happens if it exceeds $800?',
    question4: 'What is the minimum recharge? How are bills calculated?',
    main: {
      content1:
        'Our advertising cost billing model is based on material impression volume and currently only supports Mintegral.',
      content2:
        'The cost per thousand impressions (CPM) for a single material is $0.5. This means that for every 1000 times a single ad material is displayed, a fee of $0.5 will be charged.',
      content3:
        'To protect the interests of advertisers, we have set a maximum cost limit for individual materials. Once the impression count for a single ad material exceeds 1,600,000, which is equivalent to reaching the cap of $800, no further cumulative charges will be applied. This means that regardless of the impression volume, the cost for a single material will not exceed the capped amount.',
      content4:
        'To use our advertising service, a minimum recharge amount of $800 is required for individual advertisers. This serves as a prepaid deposit to ensure the continuity and stability of ad placements.',
      example: {
        describe: 'Billing Example:',
        title:
          "Let's illustrate with an example of simultaneous placements of playable materials over different months. Here are the billing scenarios for each month:",
        October: {
          title:
            ' In October, the following materials A, B, C, and D were created and started running:',
          materialA: 'Material A: 500,000 impressions',
          materialB: 'Material B: 450,000 impressions',
          materialC: 'Material C: 600,000 impressions',
          materialD: 'Material D: 550,000 impressions',
          cost: 'Expense calculation for October:',
          materialACost:
            'Material A cost: 500,000 impressions ÷ 1000 × $0.5/CPM = $250',
          materialBCost:
            'Material B cost: 450,000 impressions ÷ 1000 × $0.5/CPM = $225',
          materialCCost:
            'Material C cost: 600,000 impressions ÷ 1000 × $0.5/CPM = $300',
          materialDCost:
            'Material D cost: 550,000 impressions ÷ 1000 × $0.5/CPM = $275',
          totalCost:
            'Total cost for October: $250 + $225 + $300 + $275 = $1,050',
        },
        November: {
          title:
            'In November, materials A and B continued running, while materials C and D ceased, and new materials E and F were created and started running:',
          materialA:
            'Material A: 1,200,000 impressions (including impressions from both October and November)',
          materialB: 'Material B: 58,000 impressions',
          materialE: 'Material E: 53,000 impressions',
          materialF: 'Material F: 48,000 impressions',
          cost: 'Expense calculation for November:',
          materialACost:
            'Material A cost: Since material A accumulated impressions from October and November that have exceeded 1.6 million impressions (500,000 + 1,200,000 = 1,700,000), the cost for this month is calculated as (1,600,000 - 500,000) impressions ÷ 1000 × $0.5/CPM = $550',
          materialBCost:
            'Material B cost: 58,000 impressions ÷ 1000 × $0.5/CPM = $29',
          materialECost:
            'Material E cost: 53,000 impressions ÷ 1000 × $0.5/CPM = $26.5',
          materialFCost:
            'Material F cost: 48,000 impressions ÷ 1000 × $0.5/CPM = $24',
          totalCost:
            'Total cost for November: $550 + $29 + $26.5 + $24 = $629.5',
        },
        tips: '*Please note that in the cost calculations for each month, we consider the impression volume of each respective material and sum up the costs for each material to obtain the total cost. The cap mechanism applies to individual materials, ensuring that their cost does not exceed the capped amount.',
      },
    },
  },
  bottom:
    '*Terms and conditions apply and are subject to interpretation by Mindworks and Mintegral.',
}
